import { Component, h } from "preact";

// State Provider
import { connect } from "redux-zero/preact";
// Component
import Loading from "./Loading";
import Question from "./Question";
import Form from "./Form";
import NoParam from "./NoParam";
import Modal from "./Modal";
import Timer from "./Timer";
import Message from './Message';
import MaintenanceMode from './MaintenanceMode';

const mapToProps = ({
	isStart,
	message,
	token,
	type,
	wantReset,
	finishTest,
	organization,
	debug,
	isValidToken,
	devMode,
	isMaintenance,
	center_timer,
	email,
	pre_test,
	fullname,
	dial_code,
	phone_number,
	level
}) => ({ isStart, message, token, type, wantReset, finishTest, organization, debug, isValidToken, devMode, isMaintenance, center_timer, level, email, pre_test, fullname, dial_code, phone_number });

const types = ['et', 'pt'];

import actions from "../store/actions";

import config from '../../config.json';

import Cookie from 'js-cookie';

// Helper
import { allowFromHosts, getParam, hasLastQuestion, validateIncludes } from '../plugins/helper';

class NeoCloud extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		let params = {
			token: getParam('token') || '',
			type: getParam('type') || 'pt',
			debug: getParam('debug') || false,
			devMode: getParam('dev_mode') || false,
			email: getParam('email') || '',
			logout: getParam('logout') || false,
			center_timer: getParam('center-timer') || null,
			pre_test: getParam('pre-test') || false,
			dial_code: getParam('dial-code') || '+1',
			phone_number: getParam('phone-number') || '',
			fullname: getParam('fullname') || '',
			level: getParam('level') || '',
		};

		this.props.saveParams(params);
		this.props.logout();

		if (params.devMode != 'true' || config.app_env == 'production') {

			if (allowFromHosts()) {
				if (hasLastQuestion()) {
					this.props.getLastQuestion()
				} else {
					this.props.verifyToken({ token: params.token });
				}

			}

		}
		// remove etest_last as pre test bulk student
		if (typeof getParam('pre-test') == "undefined") Cookie.remove('etest_last')
	}

	/** @return {JSX.Element} */
	renderIfParamExist() {
		const { isStart, devMode } = this.props;

		if ((window.localStorage && window.localStorage.getItem('token')) || this.hasTypeAndTokenParam() || devMode == 'true' && config.app_env == 'development') {
			return isStart ? <Question /> : <Form />;
		}

		return <NoParam />;
	}

	/**
	 * Check if url has type and token query param.
	 * The token param will validate later
	 * in component did mount, using axios / http request
	 *
	 * @return {boolean}
	 */
	hasTypeAndTokenParam() {
		const { token, type } = this.props;
		// revisi
		return (token && (type && validateIncludes(types, type)));
	}

	timerClass() {
		const { center_timer } = this.props;

		if (center_timer) {
			return 'et-justify-center'
		}

		return 'et-justify-end et-col-span-2';
	}


	/**
	 * Check if pre-test is true and cookies have setup on storage.
	 * set parameter for candidate from pre-test
	 * and if pre-test is false
	 * only set email
	 * @returns string
	 */
	handleURLLogo() {
		const { token, email, pre_test, fullname, dial_code, phone_number } = this.props;
		if (pre_test == "true" && Cookie.get('etest_last') && !getParam('email')) {
			return "?email=" + email + "&fullname=" + fullname + "&dial-code=" + dial_code + "&phone-number=" + phone_number + "&pre-test=" + pre_test + "&center-timer=center&token=" + token
		}
		return "?email=" + (getParam('email') ? getParam('email') : '')
	}

	render({ message, wantReset, finishTest, isValidToken, isMaintenance }) {
		const org_logo = Cookie.get('org_logo');

		return !isMaintenance ? (
			<div className="wrapper" style={{ "min-height": '100vh', 'background-color': '#f9f9f9' }}>
				{message && <Message message={message} />}
				<nav className="et-relative et-bg-white et-grid et-grid-cols-3">
					<div className="et-flex et-flex-wrap et-items-center">
						<div className="et-justify-center et-items-center et-p-2 et-flex">
							<a href={this.handleURLLogo() || ''}>
								<img
									id="neologoimage"
									src={org_logo || "https://neo.dyned.com.cn/assets/img/logo_neo.svg"}
									className="et-w-24 lg:et-w-32"
								/>
							</a>
						</div>
					</div>

					{!finishTest && (
						<div className={`et-flex md:et-hidden et-flex-wrap et-items-center ${this.timerClass()}`}>
							<div className="et-justify-center et-items-center et-p-2 lg:et-p-5 et-flex">
								<Timer />
							</div>
						</div>
					)}
					<div></div>
				</nav>
				<div className="et-flex et-items-center app">
					{isValidToken ? this.renderIfParamExist() : <NoParam />}
					<Loading />
				</div>
				{wantReset && <Modal />}
			</div>
		) : <MaintenanceMode />
	}
}

export default connect(
	mapToProps,
	actions
)(NeoCloud);
